import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { Divider, Flex, Text } from "@paguelofacil/pf-components";

import { STEPS } from "../services/utils/Constants";
import { language, languageDefault } from "../services/utils/Language";
import { useRedirectWithoutSession } from "../hooks/useRedirectWithoutSession";

import { HeaderPayment } from "../components/HeaderPayment";
import LogoCryptofacil from "../assets/images/logo-cryptofacil.png";
import PfLogo from "../assets/images/pf-logo.png";
import { ButtonBack } from "../components/ButtonBack";
import PaymentAmount from "../components/PaymentAmount";
import { PayWithQr } from "../components/PaymentQr";

const PfContainer = () => {
    useRedirectWithoutSession();
    const navigate = useNavigate();

    const [step, setStep] = useState({ ref: STEPS.AMOUNT, data: { amount: 0 } });

    const handleAmount = amount => {
        setStep({
            ref: STEPS.SCAN_QR,
            data: {
                amount: amount,
            },
        });
    };

    const handleBack = stepToBack => {
        setStep({
            ...step,
            ref: stepToBack,
        });
    };

    const handleShowStepsForPay = () => {
        alert("mostrar pasos para pagar con crypto");
    };

    return (
        <Flex direction="column" width="auto" minW="auto" className="container-payment">
            <Flex gap="0.5rem" wrap="nowrap">
                <img src={LogoCryptofacil} alt="Logo Cryptofacil" className="img-cryptofacil-card-payment" />
                <Divider orientation="vertical" height="1px" width="1.5rem" />
                <img src={PfLogo} alt="Logo Paguelofacil" width={135} className="img-pf-card-payment" />
            </Flex>
            <HeaderPayment
                title={
                    <FormattedMessage
                        id={language.title_charge_pf_crypto}
                        defaultMessage={languageDefault.title_charge_pf_crypto}
                    />
                }
                handleShowStepsForPay={handleShowStepsForPay}
            />

            {STEPS.AMOUNT === step.ref ? (
                <></>
            ) : (
                <Flex gap="0">
                    <ButtonBack handleBack={() => handleBack(STEPS.AMOUNT)} />
                    <Text variant="caption" weight="regular" style={{ maxWidth: "450px" }}>
                        <FormattedMessage
                            id={language.scan_qr_pay_app}
                            defaultMessage={languageDefault.scan_qr_pay_app}
                        />
                    </Text>
                </Flex>
            )}

            {STEPS.AMOUNT === step.ref && (
                <PaymentAmount
                    handleBack={() => navigate("/cryptofacil/home")}
                    handle={handleAmount}
                    setStep={setStep}
                    hasBalance={false}
                    showSteps={false}
                />
            )}
            {STEPS.SCAN_QR === step.ref && (
                <>
                    <PayWithQr amountToRecharge={step.data.amount} />
                    <Text variant="caption" weight="regular" style={{ margin: "0.5rem 0" }}>
                        <FormattedMessage
                            id={language.first_term_conditions}
                            defaultMessage={languageDefault.first_term_conditions}
                        />
                        &nbsp;
                        <a href="http://www.paguelofacil.com/terminos-y-condiciones/" target="_blank" rel="noreferrer">
                            <FormattedMessage
                                id={language.term_conditions}
                                defaultMessage={languageDefault.term_conditions}
                            />
                        </a>
                        &nbsp;
                        <FormattedMessage
                            id={language.second_term_conditions}
                            defaultMessage={languageDefault.second_term_conditions}
                        />
                    </Text>
                </>
            )}
        </Flex>
    );
};

export default PfContainer;
